__turbopack_context__.v({
  "chip": "landing-uk-story-module__8AU2uq__chip",
  "packet": "landing-uk-story-module__8AU2uq__packet",
  "panel": "landing-uk-story-module__8AU2uq__panel",
  "run": "landing-uk-story-module__8AU2uq__run",
  "spine": "landing-uk-story-module__8AU2uq__spine",
});
